import type { FC } from 'react';
import { Button } from '@/DesignSystem/Component';
import { commentListHasNextPageSelector } from '@/Module/Comment/Store/Selector/commentListHasNextPageSelector';
import { commentNextPageAction } from '@/Module/Comment/Store/Slice/CommentSlice';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
const CommentListPagination: FC = () => {
  const dispatch = useAppDispatch();
  const hasNextPage = useAppSelector(commentListHasNextPageSelector);
  const isLoading = useAppSelector(state => state.comment.isLoading);
  const total = useAppSelector(state => state.comment.total);
  const ids = useAppSelector(state => state.comment.ids);
  const showMore = total > ids.length;
  const onNextPageClick = () => {
    dispatch(commentNextPageAction());
  };
  if (!hasNextPage) return null;
  return <div data-sentry-component="CommentListPagination" data-sentry-source-file="CommentListPagination.tsx">
      {showMore && <div className="my-2 flex justify-center sm:my-8 ">
          <Button onClick={onNextPageClick} className="w-full md:w-auto" variant="shadow" color="orange" radius="circle" size="large" isLoading={isLoading} bold>
            نمایش بیشتر
          </Button>
        </div>}
    </div>;
};
export default CommentListPagination;